module.exports = __webpack_public_path__ + "img/8a161a6cc17007e75391846b7fd8200f.png";